import { GiftCardPurchase } from 'storage/types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import priceFormat from 'utils/formats/priceFormat';
import { Row, Col, Card } from 'antd';
import styles from './GiftCardSummaryCard.module.scss';

interface Props {
  item: GiftCardPurchase;
}

const GiftCardSummaryCard: FC<Props> = ({ item }: Props) => {
  const { t } = useTranslation();

  return (
    <Row justify="center">
      <Col xs={20} lg={15}>
        <Card className={styles.Card}>
          <h2 className={styles.Title}>{t('checkout.summary.giftCard')}</h2>
          <p>
            {t('checkout.summary.from')} {item.from}
          </p>
          <p>
            {t('checkout.summary.to')} {item.to}
          </p>
          <p className={styles.SubTotal}>
            {t('checkout.summary.subTotal')}
            {priceFormat.format(Number(item.amount))}
          </p>
        </Card>
      </Col>
    </Row>
  );
};

export default GiftCardSummaryCard;
